import { Spinner } from 'react-bootstrap';
import { Colors } from '../../../../themes/colors';
import TabNavigator from '../../../commonComponents/Tabs/TabNavigator';
import TabScreen from '../../../commonComponents/Tabs/TabScreen';
import { CandidatesScreen } from './CandidatesScreen';
import { Header } from './components/Header';
import { JobInformationScreen } from './JobInformationScreen';
import { OnsiteInterviewScreen } from './OnsiteInterviewScreen';
import { useProfileInfo } from './hooks/useProfileInfo';

export const PermanentJobDetailV2 = ({ match, history }) => {
  const { officeId, jobId, currentTab } = match.params || {};

  const { user, job, isLoading } = useProfileInfo({ officeId, jobId });

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '50px' }}>
        <Spinner
          animation="border"
          role="status"
          variant="info"
          style={{
            height: 30,
            width: 30,
            marginLeft: 20,
            marginTop: 10,
          }}
        />
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        height: '100vh',
        overflowY: 'auto',
        flexDirection: 'column',
        position: 'relative',
        alignItems: 'center',
        backgroundColor: Colors.background,
        paddingBottom: 120,
      }}
    >
      <Header user={user} job={job} />

      <TabNavigator
        initialTab="jobInformation"
        currentTab={currentTab || 'jobInformation'}
        onTabChange={(tab) => history.push(`/permanent-job/office/${officeId}/job/${jobId}/${tab}`)}
      >
        <TabScreen
          name="jobInformation"
          options={{ title: 'Job Information' }}
          component={JobInformationScreen}
        />
        <TabScreen
          name="candidates"
          options={{ title: 'Candidates' }}
          component={CandidatesScreen}
        />
        <TabScreen
          name="onsiteInterview"
          options={{ title: 'Onsite Interview' }}
          component={OnsiteInterviewScreen}
        />
      </TabNavigator>
    </div>
  );
};
